import { api } from './client';

export type WordOfTheDay = {
  id: string;
  date: string;
  word: string;
  ipa: string;
  part_of_speech: string;
  translation_ru: string;
  translation_kk: string;
  definition: string;
  example: string;
  example_ru: string;
  audio_url: string;
  level: string;
};

export const wotdApi = {
  // Today's shared word (lazily generated server-side) + whether this student
  // has already studied it (then the card is hidden until tomorrow).
  async getToday() {
    const { data } = await api.get('/vocab/word-of-the-day');
    return data as { word: WordOfTheDay | null; studied: boolean };
  },
  /**
   * Слово дня для незарегистрированного посетителя (гостевая ручка на шлюзе).
   * Отметки «изучено» здесь нет — её некому ставить: гостя в базе не существует.
   */
  async getTodayPublic() {
    const { data } = await api.get('/vocab/public/word-of-the-day');
    return data as { word: WordOfTheDay | null };
  },

  /**
   * Поиск слова в ОБЩЕМ словаре без входа — для гостя (договор guest-mode.md, раздел для B).
   *
   * ⚠️ Ручки на сервере пока нет; зовётся только при включённом `guest_vocab_search`. Сервер обязан
   * только читать уже разобранные слова, без ИИ и озвучки: иначе гость тратит деньги без лимита.
   * Нет слова (404) — `word: null`, это обычный ответ, а не ошибка.
   */
  async lookupPublic(q: string) {
    try {
      const { data } = await api.get('/vocab/public/lookup', { params: { q } });
      return data as { word: WordOfTheDay | null };
    } catch (e) {
      if ((e as { status?: number })?.status === 404) return { word: null };
      throw e;
    }
  },

  async study() {
    await api.post('/vocab/word-of-the-day/study');
  },
};
